// 環境変数 process.env.LOG_LEVELとは名称が似ているが別物である。こちらは NewRelicLogHelper に渡すログレベルのリテラルを定義する定数。
// as const により各プロパティをリテラル型（'info' / 'warn' / 'error'）に固定する。
// as const がない場合、TypeScript はオブジェクトのプロパティが変更可能と判断し
// 値を string 型に広げてしまうため、ユニオン型を導出できなくなる。
export const LOG_LEVEL = {
  INFO: 'info',
  WARN: 'warn',
  ERROR: 'error',
} as const

// 定数を追加する時は合わせて JSON_PARSE_RAW_LOG_SOURCE_WHITELIST に追加するか検討する必要がある。
// token などの個人情報を含む可能性がある source は追加しない
export const LOG_SOURCES = {
  RECEIVE_STOCK_IDS: 'receive-stock-ids',
  FETCH_PICKUP: 'fetch-pickup',
  RECEIVE_USER_DATA: 'receive-user-data',
  REQUEST_SHARE_ACTION: 'request-share-action',
  RETRY_GRAPHQL: 'retry-graphql',
  RECEIVE_BFF_NETWORK_ERROR: 'receive-bff-network-error',
  RECEIVE_SCHEMA_URL: 'receive-schema-url',
}

// jsonParse のログに raw を含めても個人情報が含まれない source のホワイトリスト
export const JSON_PARSE_RAW_LOG_SOURCE_WHITELIST: ReadonlySet<string> = new Set(
  [
    LOG_SOURCES.RECEIVE_STOCK_IDS,
    LOG_SOURCES.FETCH_PICKUP,
    LOG_SOURCES.REQUEST_SHARE_ACTION,
    LOG_SOURCES.RETRY_GRAPHQL,
    LOG_SOURCES.RECEIVE_BFF_NETWORK_ERROR,
  ]
)
